import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const MarketingSection = () => {
  const navigate = useNavigate();
  const selectedTeam = localStorage.getItem("selectedTeam") || "";

  // Simple Project Nova Design System styles
  const styles = {
    primaryColor: "#1d0c46", // Deep Indigo
    secondaryColor: "#caa968", // Muted Gold
    backgroundColor: "#f8fafc", // Light gray background
    textColor: "#0f172a",
    textHeaders: "#1d0c46", // Deep Indigo for headers
    borderColor: "rgba(255, 255, 255, 0.18)", // Glass border
    glassEffect: "rgba(255, 255, 255, 0.7)",
    glassBorder: "rgba(255, 255, 255, 0.18)",
    cardShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    cardShadowHover: "0 4px 16px rgba(0, 0, 0, 0.1)"
  };

  return (
    <div className="mb-4">
      {/* Simple Hero Section */}
      <div className="bg-white border border-gray-200 p-8 text-center relative z-10">
        <h1 
          className="text-3xl md:text-4xl font-bold mb-3" 
          style={{ fontFamily: 'Raleway, sans-serif', color: styles.textHeaders }}
        >
          Welcome to Cryptique Analytics
        </h1>
        <p 
          className="text-lg max-w-2xl mx-auto mb-6" 
          style={{ fontFamily: 'Raleway, sans-serif', color: styles.textColor }}
        >
          Track both on-chain and off-chain user behavior with a comprehensive analytics platform built for Web3.
        </p>
        
        <div className="flex flex-wrap gap-3 justify-center">
          <button 
            onClick={() => navigate(`/${selectedTeam}/analytics/reports`)}
            className="px-5 py-2.5 rounded-none font-medium text-sm transition-colors duration-200 hover:bg-[#140830]"
            style={{ 
              backgroundColor: styles.primaryColor, 
              color: 'white',
              fontFamily: 'Raleway, sans-serif'
            }}
          >
            Explore Reports
          </button>
          <a 
            href="https://cryptique.gitbook.io/cryptique" 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-5 py-2.5 rounded-none font-medium text-sm transition-colors duration-200 hover:bg-[#b89554] flex items-center"
            style={{ 
              backgroundColor: styles.secondaryColor, 
              color: styles.primaryColor,
              fontFamily: 'Raleway, sans-serif'
            }}
          >
            Documentation
            <ExternalLink size={16} className="ml-2" />
          </a>
        </div>
      </div>

    </div>
  );
};

export default MarketingSection;